// extracted by mini-css-extract-plugin
module.exports = {"updateAlias":"updateAlias_updateAlias__2Lfm_","header":"updateAlias_header__1jxUf","saveButton":"updateAlias_saveButton__3a6Tp","cancelButton":"updateAlias_cancelButton__Oxr0X"};